import React from "react";
import { useChannel } from "../core/hooks/useChannel";
import { SectionEditor } from "./SectionEditor";
import { DesignerMessages } from "./types";
import { useDesigner } from "./useDesigner";
import { newID } from "../core/utils/unique";
import { SubReportEditor } from "./SubReportEditor";
import { AllContent, ReportStructure, Section, SubReport, TOC } from "../core/pdf/types";
import { ConditionalController, useConditional } from "../core/hooks/useConditional";
import { Modal } from "../core/ui/Modal";
import { IconChoiceModal } from "../core/ui/IconChoice";
import { ElementState } from "./useElementContext";
import { ButtonDef } from "../core/form/ButtonDef";
import { pasteHtmlAtCaret } from "../core/utils/html";

export function Structure(props: {
	structure: ReportStructure,
}) {

	const designer = useDesigner();

	const [token, setToken] = React.useState("");

	useChannel(designer.channel, React.useCallback((msg) => {
		if (msg.type === DesignerMessages.REFRESH_ROOT) {
			setToken(newID());
		}
	}, []));

	const sections = [];
	for(let s of props.structure.sections) {
		if (!s.id) s.id = designer.nextID();

		if (s.type === "section") {
			sections.push(
				<SectionEditor section={s} key={s.id + token} />
			);

		} else if (s.type === "sub-report") {
			sections.push(
				<SubReportEditor subReport={s as any} embedded={false} key={s.id + token} />
			);

		}
	}

	// let contextMenu = useConditional(() => {
	// 	return (
	// 		<ContextMenu
	// 			controller={contextMenu}
	// 		/>
	// 	)
	// });

	return (
		<div
			className={"structure " + props.structure.layoutType}
			// onContextMenu={(e) => {
			// 	contextMenu.show({});
			// }}
		>
			{sections}
			{/* {contextMenu.render()} */}
		</div>
	);
}

// function ContextMenu(props: {
// 	controller: ConditionalController<any>
// }) {
// 	const { controller } = props;

// 	const designer = useDesigner();

// 	const focused = designer.focus;

// 	let elementContext: ElementState | undefined;
// 	if (focused) {
// 		elementContext = designer.getContext(focused.id!);
// 	}

// 	let toRefresh: any;
// 	let contentArray: any;
// 	if (focused) {
// 		const f = focused as any;
// 		if (f.content) {
// 			contentArray = f.content;
// 			toRefresh = f;
// 		} else {
// 			// see if parent of what has the focus has content[]
// 			const context = designer.getContext(focused.id!);
// 			if (context) {
// 				const p = context.parent.def as any;
// 				if (p && p.content) {
// 					contentArray = p.content;
// 					toRefresh = p;
// 				}
// 			}
// 		}
// 	}

// 	const options: ButtonDef[] = [];

// 	if (contentArray) {
// 		options.push(
// 			{ title: "Paragraph", id: "p", icon: "paragraph" },
// 			{ title: "Page Break", id: "pagebreak", icon: "pageBreak" },
// 			{ title: "List", id: "list", icon: "list" },
// 			{ title: "Table", id: "table", icon: "table" },
// 			{ title: "Group", id: "group", icon: "group" },
// 			{ title: "Image", id: "image", icon: "image" },
// 			{ title: "Sub Report", id: "sub-report", icon: "document" },
// 			{ title: "Signature Block", id: "sig-block", icon: "signature" },
// 			{ title: "Tag", id: "tag", icon: "tag" },
// 			{ title: "Link", id: "link", icon: "link" },
// 		);
// 	}

// 	if (focused && (focused.type === "p" || focused.type === "heading")) {
// 		options.push(
// 			{ title: "Field", id: "field", icon: "field" },
// 		);
// 	}

// 	if (focused && (focused.type === "section")) {
// 		options.push(
// 			{ title: "Table of Contents", id: "toc" },
// 		);
// 	}

// 	return (
// 		<IconChoiceModal
// 			title="Add"
// 			onCancel={controller.close}
// 			showSave={false}
// 			size="width-50vw"
// 			options={options}
// 			onChoose={(option, e) => {

// 				if (!focused) return;

// 				const type = option.id!;

// 				if (type === "field") {
// 					const name = "field";
// 					pasteHtmlAtCaret(
// 						`<span
// 							class="field-token"
// 							contentEditable="false"
// 							id="${designer.nextID()}"
// 							data-options='${encodeURIComponent(JSON.stringify({}))}'
// 						>${name}</span>
// 						`,
// 					);

// 					// force a change event
// 					designer.broadcastToContent(focused.id!, {
// 						type: DesignerMessages.CHANGED,
// 					})

				
// 				} else if (focused && (focused.type === "section") && type === "sub-report") {
// 					const obj = designer.createItem("sub-report") as SubReport;
// 					const i = designer.structure.sections.indexOf(focused as any);
// 					designer.structure.sections.splice(i+1, 0, obj as any);

// 					designer.setFocus(obj);
// 					designer.refreshRoot();

// 				} else if (type === "toc") {
// 					const obj = designer.createItem("toc") as TOC;
// 					const s = focused as Section;
// 					s.content.push(obj);

// 					designer.refreshRoot();

// 				} else {
// 					const obj = designer.createItem(type);
// 					const currentIndex = contentArray.indexOf(focused);
// 					if (currentIndex >= 0) {
// 						let i = currentIndex;
// 						if (!e.shiftKey) i++;
// 						contentArray.splice(i, 0, obj);
// 					} else {
// 						if (e.shiftKey) {
// 							contentArray.splice(0, 0, obj);
// 						} else {
// 							contentArray.push(obj);
// 						}
// 					}

// 					designer.setFocus(obj);
// 					designer.refreshItem(toRefresh);

// 				}

// 				controller.close();
				
// 			}}
// 		>
			
// 		</IconChoiceModal>
// 	)
// }